import { render, staticRenderFns } from "./ModalAdditionalNote.vue?vue&type=template&id=1982e5c7&"
import script from "./ModalAdditionalNote.vue?vue&type=script&lang=js&"
export * from "./ModalAdditionalNote.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports